export default "__VITE_PUBLIC_ASSET__fe882a04__"